import { render } from "./ChatHistory.vue?vue&type=template&id=91dff34c&scoped=true&ts=true"
import script from "./ChatHistory.vue?vue&type=script&lang=ts"
export * from "./ChatHistory.vue?vue&type=script&lang=ts"

import "./ChatHistory.vue?vue&type=style&index=0&id=91dff34c&lang=scss&scoped=true"

import exportComponent from "/Users/TomaccioD/Documents/other/nigma-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91dff34c"]])

export default __exports__